import defaultColor from "@/components/color";

const dataText = JSON.stringify([
    { value: 60, name: 'Visit' },
    { value: 40, name: 'Inquiry' },
    { value: 20, name: 'Order' },
    { value: 80, name: 'Click' },
    { value: 100, name: 'Show' }
])

export default {
    cptDataForm:{
        dataSource: 1, pollTime: 0, dataText: dataText,
    },
    attribute:{
        color:defaultColor,
        title: {
            text: '标题一',
            left: 'top',
            top: 'center',
            textStyle: { fontSize: 18, color: '#ccc' }
        },
        legend: {
            show: true,
            left: 'center',
            top: 'bottom',
            orient: 'horizontal',
            textStyle: {
                color:'#6aa9e4',
                fontSize:14
            }
        },
        series:{
            orient:'vertical',
            gap: 0,
            top:0,
            bottom:30,
            left:10,
            right:10,
            label: {
                show: true,
                position: 'inside',
                color:'#fff',
                fontSize:12
            },
            labelLine: {
                show:true,
                length: 100,
                lineStyle: {
                    width: 1,
                    type: 'solid'
                }
            },
            funnelAlign:'center',
            sort:'descending'//ascending,none
        },
        tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(0,0,0,0.5)',
            textStyle: {
                color: "#fff",
            },
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                type: 'shadow',       // 默认为直线，可选为：'line' | 'shadow'
            }
        },
        cptTableData: [{ "name": "维度", "value": "", "namekey": "name" },{ "name": "指标", "value": "", "namekey": "value" }] 
    },
}
